module.exports = __webpack_public_path__ + "img/chat_emoticon_synot_001.png?14cfb6424a4c19e2150aa7c475db183a";